<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="title">GILDED</h1>
<p class="subtitle">BREAKING FREE FROM THE CAGE OF AMBITION, PERFECTIONISM, AND THE RELENTLESS PURSUIT OF MORE</p>
<p class="author">KEREN ELDAD</p>
<div class="img_container1">
<img alt="image" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?742236f2